import React, { useMemo } from 'react';
import { Row, Col, Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';
import LeagueSeasonLeaderboardPlayers from './LeagueSeasonLeaderboardPlayers';

const LeagueSeasonLeaderboardSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Leaderboard Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Stat",
                                key: "stat",
                                format: "titleCase",
                            },
                            {
                                label: "Stat Type",
                                key: "statType",
                                format: "titleCase",
                            }
                        ]}
                        columnB={[
                            {
                                label: "Type",
                                key: "type",
                                format: "titleCase",
                            },
                            {
                                label: "Season",
                                key: "season",
                                format: "ModelLink",
                            },
                            {
                                label: "Divisions",
                                key: "divisions",
                                format: "ModelLink",
                            }
                        ]}
                        columnC={[
                            {
                                label: "Host",
                                key: "host",
                                format: "ModelLink",
                            }
                        ]}
                    />

                </Panel>

                <Space />

                <LeagueSeasonLeaderboardPlayers
                    data={data}
                />

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default LeagueSeasonLeaderboardSingleView;
